import React from 'react';
import sisterPhotoOne from '../assets/SisterPicture.jpg';
import brotherPic from '../assets/brotherPicture.jpg';

function Team() {
  return (
    <div>
      <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-20">
        <div className="mx-auto mb-10 lg:max-w-xl sm:text-center">
          <h2 className="max-w-lg mb-6 font-sans text-3xl font-bold leading-none tracking-tight text-gray-900 sm:text-4xl md:mx-auto">
            Our Founders
          </h2>
        </div>
        <div className="grid gap-10 mx-auto sm:grid-cols-2 lg:grid-cols-2 lg:max-w-screen-lg">
          <div>
            <div className="relative pb-56 mb-4 rounded  lg:pb-64">
              <img
                className="absolute object-scale-down w-full h-full rounded"
                src={sisterPhotoOne}
                alt="Person"
              />
            </div>
            <div className="flex flex-col sm:text-center">
              <p className="text-lg font-bold">Erlendre Lamy</p>
              <p className="mb-5 text-xs text-gray-800">Chairwoman</p>
              <div className="flex items-center space-x-3 sm:justify-center">
                <a
                  href="/"
                  className="text-gray-600 transition-colors duration-300 hover:text-deep-purple-accent-400"
                >
                  <svg
                    class="w-6 h-6 text-blue-500 fill-current"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 448 512"
                  >
                    <path d="M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"></path>
                  </svg>
                </a>
              </div>
            </div>
          </div>
          <div>
            <div className="relative pb-56 mb-4 rounded lg:pb-64">
              <img
                className="absolute object-scale-down object-cover w-full h-full rounded"
                src={brotherPic}
                alt="Person"
              />
            </div>
            <div className="flex flex-col sm:text-center">
              <p className="text-lg font-bold">Sammy Lamy</p>
              <p className="mb-5 text-xs text-gray-800">CEO</p>
              <div className="flex items-center space-x-3 sm:justify-center">
                <a
                  href="https://www.linkedin.com/in/sammylamy/"
                  className="text-gray-600 transition-colors duration-300 hover:text-deep-purple-accent-400"
                >
                  <svg
                    class="w-6 h-6 text-blue-500 fill-current"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 448 512"
                  >
                    <path d="M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"></path>
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section className="p-6 md:p-12 text-center md:text-left rounded-md">
        <div className="flex justify-center">
          <div className="max-w-3xl">
            <div className="block p-6 rounded-lg shadow-lg bg-white m-4">
              <div className="md:flex md:flex-row">
                <div className="md:ml-6">
                  <p className="text-gray-500 font-light mb-6">
                    Erlendre Lamy is the Chairwoman of Jobs For Us Staffing
                    Agency, a premier staffing agency that specializes in
                    connecting employers with highly skilled and motivated
                    immigrant workers from Latin America and the Caribbean. With
                    over 20 years of experience as a registered nurse, Erlendre
                    brings a wealth of knowledge and expertise to the agency.
                    Erlendre is a graduate of Florida International University,
                    where she earned her nursing degree. Throughout her career,
                    she has gained valuable experience working in various
                    settings, including hospitals, clinics, and long-term care
                    facilities. During the COVID-19 pandemic, she worked as a
                    front-line worker, providing care and support to individuals
                    and families affected by the global pandemic. Additionally,
                    Erlendre has experience as a travel nurse, working in
                    different locations across the country. As Chairwoman of
                    Jobs For Us Staffing Agency, Erlendre is dedicated to
                    providing employers with the best service possible by
                    matching the right worker with the right job. She is
                    passionate about helping immigrant workers succeed in their
                    new environment and having them integrated into the
                    community. Her experience as a front-line worker during the
                    pandemic, gives her a unique understanding of the importance
                    of having a reliable and motivated workforce, especially
                    during difficult times. Under Erlendre's leadership, Jobs
                    For Us Staffing Agency is dedicated to providing employers
                    with reliable and motivated workforce, while helping
                    immigrant workers succeed in their new environment. Her
                    extensive experience in the healthcare field gives her a
                    unique perspective on the importance of matching the right
                    worker with the right job, and ensuring compliance with
                    immigration laws.
                  </p>
                  <p className="font-semibold text-xl mb-2 text-gray-800">
                    Erlendre Lamy
                  </p>
                  <p className="font-semibold text-gray-500 mb-0">Chairwoman</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="p-6 md:p-12 text-center md:text-left rounded-md">
        <div className="flex justify-center">
          <div className="max-w-3xl">
            <div className="block p-6 rounded-lg shadow-lg bg-white m-4">
              <div className="md:flex md:flex-row">
                <div className="md:ml-6">
                  <p className="text-gray-500 font-light mb-6">
                    Sammy Lamy is the CEO of Jobs For Us Staffing Agency, a
                    premier staffing agency that specializes in connecting
                    employers with highly skilled and motivated immigrant
                    workers from Latin America and the Caribbean. With over 11
                    years of professional experience, Sammy brings a wealth of
                    knowledge and expertise to the agency. Sammy began his
                    career as an accountant, working for several companies and
                    honing his skills in financial analysis and management. He
                    then transitioned to the field of real estate development,
                    where he gained valuable experience in project management
                    and strategic planning. Sammy holds a Bachelor of Science in
                    Accounting from Florida A&M University and a Master's degree
                    in Real Estate from Florida International University. His
                    education and experience have equipped him with the skills
                    and knowledge to successfully manage and grow the agency. As
                    CEO of Jobs For Us Staffing Agency, Sammy is committed to
                    providing employers with the best service possible, by
                    ensuring compliance with immigration laws, providing support
                    and resources for immigrant workers, and matching the right
                    worker with the right job. He is passionate about helping
                    immigrants integrate into the community and build a better
                    future for themselves and their families. Under Sammy's
                    leadership, Jobs For Us Staffing Agency is dedicated to
                    providing employers with a reliable and motivated workforce,
                    while helping immigrant workers succeed in their new
                    environment.
                  </p>
                  <p className="font-semibold text-xl mb-2 text-gray-800">
                    Sammy Lamy
                  </p>
                  <p className="font-semibold text-gray-500 mb-0">CEO</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Team;
